<script>
import { eventBus } from "../../main";
import { mapGetters, mapActions } from "vuex";
import Peer from "peerjs-client";
import { constants } from "zlib";

export default {
  name: "langs-mixin",

  data() {
    return {
      $messages: null,
      /*$messages: {
                    browse_project: "Browse Project",
                    log_in: "Log in",
                    sign_up: "Sign up",
                    why_build_title: "Why We Built",
                    why_build_details: "As an IT consultant, we lacked a community where IT consultants could share experiences,find resources as well as projects - without the middleman.",
                    it_professionals: "IT Professionals",
                    author_title: "Yoga sang, SSIS consultant",
                    author_quotation: "It feels great to be able to find projects on my own without a middleman.",
                    latest_members: "Our latest members",
                    login_form_title: "Login to your account",
                    sign_up_with: "Sign Up With",
                    sign_in: "Sign in",

                    create_password_form_title: "Create Your Account Password",
                    submit: "Submit",

                    //Profile Texts
                    hourly_rate: 'Hourly Rate',
                    hour: 'hr',
                    connections: 'Connections',
                    profile_views: 'Who viewed your profile',
                    posts_views: 'Views of your posts',
                    article_views: 'Articles views',
                    search_appearances: 'Search appearances',
                    general_info: 'General Info',
                    portfolio: 'Portfolio',
                    employment: 'Employment',
                    dashboard: 'Dashboard'
                },*/
    };
  },

  computed: {
    ...mapGetters(["getHelper"]),
  },
  methods: {
    ...mapActions(["FETCH_MESSAGES"]),
    $t(key) {
      return this.$data.$messages ? this.$data.$messages[key] : "key_" + key;
    },
    $fetchMessages(page, locale) {
      let vm = this;
      // vm.$startLoader()
      // vm.$http.post(vm.$fullUrl(vm.getHelper.relativeUrls.getTranslations),
      //     {
      //         group: page,
      //         locale: locale
      //     }
      // ).then(function (response) {
      //         vm.$data.$messages = response.data
      //     }
      // ).catch(function (error) {
      //     console.log(error)
      // }).finally(() => {
      //     vm.$stopLoader()
      // })

      console.log(this.getHelper.api.serverUrl);

      vm.$store.dispatch("FETCH_MESSAGES", {
        group: page,
        locale: locale,
      });
    },
    $fullUrl(partialUrl) {
      return this.getHelper.api.fileUrl + partialUrl;
    },
    $startLoader() {
      eventBus.$emit("loading", { loading: true, reset: false });
    },
    $stopLoader() {
      eventBus.$emit("loading", { loading: false, reset: false });
    },
    initializeApp() {
      /*this.$store.state.authToken = this.sessionStorage.authToken;
                this.$store.state.userId = this.sessionStorage.userId;*/
      // this.$store.dispatch('initializeAppData', {
      //     token: this.sessionStorage.authToken,
      //     id: this.sessionStorage.userId
      // })
    },

    $getPeer() {
      new Peer(this.$store.state.userId, {
        host: "dev.meritios.com", //'127.0.0.1'
        port: "3000",
        path: "/webrtc",
      });
    },
  },
};
</script>